export interface IGetDevicesPositionsByPolygonInputDto {
    coordinates: [number, number][];
    from: string;
    to: string;
}
